import Component from '../core/Component'
import { queryAll } from '../utils/dom'
import PlanBubble from './PlanBubble'
import enquire from 'enquire.js'
import { queries } from '../core/config'
import EventBus from '../core/EventBus'

export const STATES = {
    ACTIVE: 'is-active',
    DRAGGING: 'is-dragging',
    CELL_ACTIVE: 'is-cell-active',
    STATIC: 'is-static'
}

export default class PlanFloor extends Component {

    constructor(element) {
        super(element)

        this.id = element.dataset.floor

        this.cache = {}
        this.current = null

        this.ref = {
            canvas: null,
            bubble: null,
            people: null,
            svg: null
        }

        this.drag = {
            active: false,
            start: {
                x: 0,
                y: 0
            },
            scroll: {
                x: 0,
                y: 0
            }
        }

        this.isStatic = false
        this.timer = null
        this.disabledMouse = false

        this.ratio = .75

        this.enquireHandler = {
            match: () => this.ratio = 1,
            unmatch: () => this.ratio = .75
        }
    }

    prepare() {
        this.parse()

        if (this.ref.bubble) {
            this.bubble = new PlanBubble(this.ref.bubble)
            this.bubble.prepare()
        }

        enquire.register(queries.mediumUp, this.enquireHandler)
        this.element.addEventListener('mousedown', ::this.handlePointerDown)
        this.element.addEventListener('mouseup', ::this.handlePointerUp)
        this.element.addEventListener('mousemove', ::this.handlePointerMove)
        this.element.addEventListener('mouseleave', ::this.handlePointerLeave)

        Object.keys(this.cache)
            .forEach(key => {
                if (this.cache[key].rect) {
                    this.cache[key].rect.addEventListener('mouseenter', () => this.handleItemPointerEnter(key))
                    this.cache[key].rect.addEventListener('mouseleave', () => this.handleItemPointerLeave(key))
                    this.cache[key].rect.addEventListener('click', () => this.handleItemClick(key))
                }
            })
    }

    destroy() {
        this.bubble.destroy()
        enquire.unregister(queries.mediumUp, this.enquireHandler)
    }

    handleItemPointerEnter(id) {
        if (!this.isStatic) {
            this.focus(id)
        }
    }

    handleItemPointerLeave(id) {
        if (!this.isStatic) {
            this.blur(id)
        }
    }

    handleItemClick(id) {
        if (!this.isStatic) {
            this.focus(id)
        }
    }

    handlePointerLeave() {
        this.drag.active = false
        this.element.classList.remove(STATES.DRAGGING)
    }

    handlePointerDown(event) {
        this.drag.active = true
        this.drag.start.x = event.clientX
        this.drag.start.y = event.clientY
        this.drag.scroll.x = this.ref.canvas.scrollLeft
        this.drag.scroll.y = this.ref.canvas.scrollTop
        this.element.classList.add(STATES.DRAGGING)
    }

    handlePointerUp(event) {
        this.drag.active = false
        this.element.classList.remove(STATES.DRAGGING)
    }

    handlePointerMove(event) {
        if (this.drag.active) {
            const xDiff = event.clientX - this.drag.start.x
            const yDiff = event.clientY - this.drag.start.y
            this.ref.canvas.scrollLeft = this.drag.scroll.x - xDiff
            this.ref.canvas.scrollTop = this.drag.scroll.y - yDiff
        }
    }

    parse() {
        this.cache = queryAll('[id^="a"]', this.element)
            .map(element => ({
                element: element,
                id: element.getAttribute('id').split('_')[0],
                type: element.tagName
            }))
            .reduce((acc, item) => {
                let group = acc[item.id]

                if (!group) {
                    group = {
                        id: item.id,
                        elements: []
                    }
                }

                group.elements.push(item.element)

                if (item.type === 'rect') {
                    group.rect = item.element
                }

                acc[item.id] = group

                return acc
            }, {})
    }

    show(route, data) {
        this.element.classList.add(STATES.ACTIVE)
        if (!this.people && this.ref.people) {
            this.people = JSON.parse(this.ref.people.innerText)
        }

        if (route && route in this.cache) {
            this.centerTo(route)
            this.focus(route, data)
        } else {
            this.center()
        }

        EventBus.emit('plan:floor:show', {
            floor: this.id
        })
    }

    hide() {
        this.isStatic = false
        this.element.classList.remove(STATES.ACTIVE)
    }

    center() {
        const box = this.ref.canvas.getBoundingClientRect()

        const x = (this.ref.canvas.scrollWidth - box.width)/2
        const y = (this.ref.canvas.scrollHeight - box.height)/2

        this.ref.canvas.scrollLeft = x
        this.ref.canvas.scrollTop = y
    }

    centerTo(cellId) {
        if (!(cellId in this.cache)) {
            return
        }

        const cell = this.cache[cellId].rect
        const box = cell.getBBox()

        const containerBox = this.ref.canvas.getBoundingClientRect()

        const x = (box.x * this.ratio - containerBox.width/2)
        const y = (box.y * this.ratio - containerBox.height/2)

        this.ref.canvas.scrollLeft = x
        this.ref.canvas.scrollTop = y
    }

    focus(cellId, data = null) {
        if (!(cellId in this.cache)) {
            return
        }

        if (data === null && this.people && cellId in this.people) {
            data = this.people[cellId]
        }

        const { elements, rect } = this.cache[cellId]

        const box = rect.getBBox()

        const coords = {
            x: (box.x + box.width/2) * this.ratio,
            y: (box.y + box.height/2) * this.ratio
        }

        if (this.bubble && data) {
            clearTimeout(this.timer)
            this.bubble.setContent(data)
            this.bubble.show(coords)
        }

        elements.forEach(element => element.classList.add(STATES.CELL_ACTIVE))

        this.current = cellId
    }

    blur(cellId = this.current) {
        if (!(cellId in this.cache)) {
            return
        }

        clearTimeout(this.timer)

        this.current = null
        const { elements } = this.cache[cellId]
        elements.forEach(element => element.classList.remove(STATES.CELL_ACTIVE))

        this.timer = setTimeout(() => {
            if (this.bubble) {
                this.bubble.hide()
            }
        }, 100)
    }

}